import axios from '@axios'

const getDefaultState = () => ({
  items: [],
  statuses: [],
  roles: [],
  countries: [],
  item: null,
  searchFields: '',
  orderBy: '',
  searchJoin: window.innerWidth < 768 ? 'or' : 'and',
  sortedBy: '',
  summary: null,
  pagination: {
    current_page: 1,
    last_page: 1,
    per_page: 25,
    total: 0,
  },
})

export default {
  namespaced: true,
  state: getDefaultState,
  getters: {},
  mutations: {
    SET_ITEMS(state, payload) {
      state.items = payload
    },
    SET_STATUSES(state, payload) {
      state.statuses = payload.data.map(item => ({
        value: item.id,
        text: item.name,
      }))
    },
    SET_ROLES(state, payload) {
      state.roles = payload
    },
    SET_COUNTRIES(state, payload) {
      state.countries = payload
    },
    SET_PAGINATION(state, payload) {
      state.pagination = payload
    },
    SET_ITEM(state, payload) {
      state.item = { ...payload }
    },
    UPDATE_ITEM(state, payload) {
      state.items = state.items.map(item => {
        if (item.id === payload.id) {
          return payload
        }

        return item
      })
    },
    SET_ITEM_SUMMARY(state, payload) {
      state.summary = { ...payload }
    },
    DELETE_ITEM(state, id) {
      state.items = state.items.filter(item => (item.id !== id))
    },
    SET_SEARCH_FIELDS(state, fields) {
      state.searchFields = fields
    },
    SET_ORDER_BY(state, order) {
      state.orderBy = order
    },
    SET_SEARCH_JOIN(state, join) {
      state.searchJoin = join
    },
    SET_SORTED_BY(state, field) {
      state.sortedBy = field
    },
    RESET_ITEM(state) {
      state.item = null
    },
    RESET_STATE(state) {
      Object.assign(state, getDefaultState())
    },
  },
  actions: {
    async getItems({ commit }, { ...payload }) {
      console.log('fields', payload)
      try {
        const { data } = await axios.get('/user/index', { params: { ...payload } })
        const { pagination } = data.meta
        const { options } = data
        const items = data.data.map(item => ({
          ...item,
          ...{ telephone: `${item.phone_country_code ? `+${item.phone_country_code}` : ''}${item.phone_number ?? ''}` },
        }))
        const {
          searchFields, search, orderBy, sortedBy, searchJoin,
        } = payload

        if (searchFields && search) {
          commit('SET_SEARCH_FIELDS', searchFields)
        }

        if (orderBy && sortedBy) {
          commit('SET_ORDER_BY', orderBy)
          commit('SET_SORTED_BY', sortedBy)
        }

        if (searchJoin) {
          commit('SET_SEARCH_JOIN', searchJoin)
        }

        commit('SET_ITEMS', items)
        commit('SET_STATUSES', options.statuses)
        commit('SET_PAGINATION', pagination)

        return data.data
      } catch (error) {
        commit('SET_ITEMS', [])
        return Promise.reject(error)
      }
    },
    async getCompany({ commit }, id) {
      try {
        const { data } = await axios.get(`/company/${id}/show`)
        return data.data
      } catch (error) {
        console.log('no commit', commit)
        return Promise.reject(error)
      }
    },
    async getItem({ commit }, id) {
      try {
        const { data } = await axios.get(`/user/${id}/show`)

        commit('SET_ITEM', data.data)
        commit('SET_ROLES', data.options.roles.data)
        commit('SET_COUNTRIES', data.options.countries.data)
        return data.data
      } catch (error) {
        commit('RESET_ITEM', [])
        return Promise.reject(error)
      }
    },
    async updateItem({ commit }, { id, payload }) {
      try {
        await axios.put(`/user/${id}/update`, {
          ...payload,
        })

        commit('UPDATE_ITEM', payload)

        return true
      } catch (error) {
        return Promise.reject(error)
      }
    },
    // eslint-disable-next-line no-unused-vars
    async changeItemsStatuses({ commit }, { ids, is_active }) {
      try {
        await axios.put('/user/change-status', {
          ids,
          is_active,
        })
        return true
      } catch (error) {
        return Promise.reject(error)
      }
    },
    async deleteItem({ commit }, id) {
      try {
        await axios.delete(`/user/${id}/destroy`)

        commit('DELETE_ITEM', id)

        return true
      } catch (error) {
        return Promise.reject(error)
      }
    },
    async getSummary({ commit }, id) {
      try {
        const { data } = await axios.get(`/user/${id}/summary`)
        commit('SET_ITEM_SUMMARY', data.data)

        return data.data
      } catch (error) {
        commit('RESET_ITEM', [])
        return Promise.reject(error)
      }
    },
    setJoin({ commit }, payload) {
      commit('SET_SEARCH_JOIN', payload)
    },
    setSearchFields({ commit }, payload) {
      commit('SET_SEARCH_FIELDS', payload)
    },

    setOrderBy({ commit }, payload) {
      commit('SET_ORDER_BY', payload)
    },
    setSortedBy({ commit }, payload) {
      commit('SET_SORTED_BY', payload)
    },
    // eslint-disable-next-line no-unused-vars
    async resetPassword({ commit }, id) {
      try {
        await axios.put(`/user/${id}/reset-password`, { id })

        return true
      } catch (error) {
        return Promise.reject(error)
      }
    },
    async recoverItem({ commit }, id) {
      try {
        await axios.put(`/user/${id}/recover`)

        commit('RESET_ITEM')
        return true
      } catch (error) {
        return Promise.reject(error)
      }
    },
  },
}
